/**
 * Offline queue for atendimento confirmations using localStorage + Service Worker postMessage.
 * Each entry: { id, url, method, body, headers, addedAt }
 */
import api from "@/lib/api";

const KEY = "offline_queue";

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
  catch { return []; }
}
function write(arr) {
  localStorage.setItem(KEY, JSON.stringify(arr));
  window.dispatchEvent(new CustomEvent("offline-queue-changed"));
}

export function enqueue(req) {
  const arr = read();
  arr.push({ ...req, id: crypto.randomUUID(), addedAt: Date.now() });
  write(arr);
  // Try background sync registration
  if ("serviceWorker" in navigator && "SyncManager" in window) {
    navigator.serviceWorker.ready.then((reg) => reg.sync.register("sync-atendimentos").catch(() => {}));
  }
}

export function pendingCount() { return read().length; }

export async function flushQueue() {
  if (!navigator.onLine) return { sent: 0, failed: 0, kept: read().length };
  const arr = read();
  if (arr.length === 0) return { sent: 0, failed: 0, kept: 0 };
  const remaining = [];
  let sent = 0, failed = 0;
  for (const item of arr) {
    try {
      await api.request({
        url: item.url,
        method: item.method || "POST",
        data: item.body,
        headers: { ...(item.headers || {}), "X-Offline-Replay": "1" },
      });
      sent += 1;
    } catch (e) {
      // 4xx are not retried; 5xx and network keep
      const status = e.response?.status;
      if (status && status >= 400 && status < 500) {
        sent += 0;
      } else {
        remaining.push(item);
        failed += 1;
      }
    }
  }
  write(remaining);
  return { sent, failed, kept: remaining.length };
}

// Auto-flush when back online
window.addEventListener("online", () => { flushQueue(); });

// Listen for SW request to flush
if ("serviceWorker" in navigator) {
  navigator.serviceWorker?.addEventListener?.("message", (event) => {
    if (event.data?.type === "FLUSH_QUEUE_REQUEST") flushQueue();
  });
}
